import React from "react";
import { Box } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";

export interface IMoreItemsBadge {
    count: number;
    tooltip: React.ReactNode;
}

// The "+N" after the visible items of a list cell, so a row with many items stays one line high. The tooltip is white
// because it holds chips and links, which are hard to read on the default dark tooltip. MUI tooltips stay open while
// hovered, so anything clickable in it is reachable.
function MoreItemsBadge({ count, tooltip }: IMoreItemsBadge) {
    return (
        // The tooltip's own padding is sized for a line of text and leaves chips crowding its edges.
        <DotLegalTooltip text={<Box sx={{ padding: 1 }}>{tooltip}</Box>} tooltipStyle="secondary" toolTipMaxWidth={400}>
            <Box
                component={"span"}
                sx={(theme) => ({
                    flexShrink: 0,
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    lineHeight: 1.4,
                    color: theme.palette.primary.dark,
                    cursor: "default",
                    whiteSpace: "nowrap",
                })}
            >
                +{count}
            </Box>
        </DotLegalTooltip>
    );
}

export default MoreItemsBadge;
